module.exports = __webpack_public_path__ + "assets/images/bg_0eb1e17b69cffc27f17e44721aa68758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = 206
// module chunks = 0